module.exports = __webpack_public_path__ + "static/img/menage1.9cd36ce0.png";